var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-wizard-button',{attrs:{"disabled":_vm.busy,"busy":_vm.busy},on:{"click":_vm.bindAll}},[_vm._v("Alle verknüpften Sensoren verbinden")])}
var staticRenderFns = []

export { render, staticRenderFns }